import styled from 'styled-components';

export const ContentPadding = styled.div`
  padding-top: 2rem;
`;
